import styled from 'styled-components'
import {
    Container,
    Heading,
    Li,
    List, ModalMUI,
    ReadMore,
    Title, Title2,
} from '../../pages/recommendations/Recommendations'
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import GlobalContext from '../GlobalContext'
import { Link } from 'react-router-dom'
import { getUrl } from "../getSubjectId";
import { NotFound } from '../personalizedHealthEvaluation/PersonalizedHealthEvaluation'
import { ConfigText } from '../healthStatus/HealthStatus'
import { TextLinkify } from "../RecomendAndNextSteps/RecomendAndNextSteps";
import AboutBiomarker from "../modals/AboutBiomarker";
import { CrossIcon } from "../../assets/icons/cross";
import ContainerContent from './../ContainerContent';

const Background = styled.div`
  width: 100%;
`

const BodyResult = styled.div`
  margin-top: 0;
`

const ResultsInterpretation = (props: any) => {
    const { t, i18n } = useTranslation()
    const { themeId } = props
    const [isModalOpen, setIsModalOpen] = useState<any>(false)
    const [readMore, setReadMore] = useState<any>({})
    const { info } = props
    const isOk = (info.interpretations || []).length > 0

    const interpretations = info.interpretations.filter((it: any) => {
        const subjectId = (it.subjectIds || [])[0];

        return !themeId || (themeId == subjectId)
    });

    return (
        <ContainerContent background='#fff'>
            <Background>
                <div data-animch='3' className={'pf pfsmall'}>
                    <Title2 data-title2>
                        <ConfigText field={'your_results_interpretaion'}>{t('yourResultsInterpretation')}</ConfigText>
                    </Title2>
                    <BodyResult>
                        {isOk && <>
                            {/*<Heading>*/}
                            {/*    <ConfigText field={'found_interpreations'}>*/}
                            {/*        According to the results of your blood test, there is evidence of a potential*/}
                            {/*        inflammatory process in your body, which may be attributed to the following factors:*/}
                            {/*    </ConfigText>*/}
                            {/*</Heading>*/}
                            <div>
                                {(interpretations || [])
                                    .filter((item: any) => item.name)
                                    .map((it: any, ind: number) => {
                                        console.log('actualText', it);
                                        
                                        let description = '';
                                        if (it.description) {
                                            if (typeof it.description === 'string') {
                                                description = it.description;
                                            } else if (typeof it.description === 'object') {
                                                const currentLang = i18n.language;
                                                description = it.description[currentLang] || it.description.en || Object.values(it.description)[0] || '';
                                            }
                                        }
                                        let nameStr = '';
                                        if (it.name) {
                                            if (typeof it.name === 'string') {
                                                nameStr = it.name;
                                            } else if (typeof it.name === 'object') {
                                                const currentLang = i18n.language;
                                                nameStr = it.name[currentLang] || it.name.en || Object.values(it.name)[0] || '';
                                            }
                                        }
                                        const text = String(description || nameStr || '')
                                        const shortText = text.slice(0, 200)

                                        const isReadMore = text.length > 200;
                                        const isReadMoreOpen = true;

                                        const actualText = isReadMoreOpen || !isReadMore ? text : shortText

                                        

                                        let opts = isReadMoreOpen ? { 'data-fade': true } : {}
                                        return (
                                            <div key={ind} className={'disDesc'}>
                                                <TextLinkify text={actualText}></TextLinkify>
                                                {/*<ReadMoreWithHeight text={actualText}></ReadMoreWithHeight>*/}
                                            </div>
                                        )
                                    })}
                            </div>
                        </>}
                        {!isOk && <>
                            <NotFound></NotFound>
                        </>}

                    </BodyResult>
                </div>
            </Background>
        </ContainerContent>
    )
}
const ReadMoreWithHeight = (props: any) => {
    const [isOpen, setIsOpen] = useState(false)
    const [cd, setCd] = useState(0)
    const elRef = useRef(null);
    const { text } = props || {};
    const MAX_HEIGHT = 200;


    const el = (elRef?.current || {}) as any;
    const height = el.offsetHeight;
    const isMore = height > MAX_HEIGHT;

    const isMoreVisible = !isOpen && isMore

    useEffect(() => {
        setCd(new Date().getTime())
    }, [text])

    const styles = {
        maxHeight: isMoreVisible ? (MAX_HEIGHT + 'px') : 'auto',
        overflow: isMoreVisible ? 'hidden' : 'none',
    }
    console.log("qqqqq styles", isMoreVisible, styles);
    return <div className={isMoreVisible ? 'isMoreVisible' : ''}>
        <div ref={elRef} dangerouslySetInnerHTML={{ __html: text }} className={'interContent'}>
        </div>
        {isMoreVisible && <a className={'isMoreBtn linkHover'} onClick={() => {
            setIsOpen(true)
        }}>Read More</a>}

    </div>
}

export default ResultsInterpretation